import * as routeNames from 'constants/routeNames';

export const ONBOARDING_COMPLETED_ROUTE = routeNames.MAIN;
